
document.addEventListener('DOMContentLoaded', function() {
  setTimeout(function(){
    const buttons = document.querySelectorAll('.custom-blog-button');
  
    buttons.forEach(button => {
      button.addEventListener('click', function() {
        console.log('Clicked')
        // Find the nearest #pdfPopup inside the same section/container
        const popup = this.closest('.custom_blog_filter-Card_wrapper')?.querySelector('#pdfPopup');
        if (popup) popup.style.display = 'flex';
      });
    });
  
    // Handle close clicks and background clicks for all modals
    const modals = document.querySelectorAll('#pdfPopup');
  
    modals.forEach(modal => {
      const closeBtn = modal.querySelector('.close_btn');
      if (closeBtn) {
        closeBtn.addEventListener('click', () => modal.style.display = 'none');
      }
  
      modal.addEventListener('click', (event) => {
        if (event.target === modal) {
          modal.style.display = 'none';
        }
      });
    });
  }, 2000)
});


$(document).ready(function(){
  $('.vs_custom_modal_close').click(function(){
      $('.vs_custom_modal').css('display','none');
  })
  // hide shop pay installment option
    $("shopify-payment-terms").hide()
  
  // check and apply color filter on load
  if($('.custom_filter_options .color_filter_option').hasClass('selected') == false){
    // $('.custom_filter_options .color_filter_option.ft_White_option').trigger('click');
    $('ul#product-grid').addClass('default_products');
  }else{
    $('ul#product-grid').addClass('filter_products');
  }
  $('.mobile-facets__open').click(function(){
    console.log("clicked");
    let check_drawer = $('.mobile-facets__main>details').attr('open');
    if(check_drawer == undefined){
      setTimeout(function(){
        $('.mobile-facets__summary').trigger('click');
      },500);  
    }
  });

  $('aside#main-collection-filters').click(function() {
      setTimeout(function(){
          var isExpanded = $('body').find('.mobile-facets__disclosure').hasClass('menu-opening');
  	 	 console.log(isExpanded);
  
  	 	if (isExpanded == true) {
   		 	$('aside#main-collection-filters').css("z-index","5");
   		} else {
   		 	$('aside#main-collection-filters').css("z-index","2")
   		}
      },100)
  	 	 
  });
  $('.mobile-facets__close').click(function (){
      $('.mobile-facets__open-wrapper').trigger('click');
  })
  // if($('.collection-Zenyth-page .color_flt_option_wrapper #yellowGoldOption').length == 1){
  //   $('.collection-Zenyth-page .color_flt_option_wrapper #yellowGoldOption').click();
  // }
  // show second image on product card hover

  setProdImageHoverListeners();

  // trigger to write review button
    $('#write-review').click(function(){
       $('button.write-question-review-button').click(); 
    });

  // close the sort collection page popup
$('.custom_sort_popup').click(function(e){
    var target = $(e.target);
    if(!target.is('#sortByPopupFilter') && !target.is('.sort_pp_list') && !target.is('.sort_pp_option ')) {
       $('.custom_sort_popup').hide();
    }
});
  // close product social icon wrap on outside click
$('body').click(function(e){
    var target = $(e.target);
    if(!target.is('.social_actions') && !target.is('.social_actions>a') && !target.is('.share_wrapper') && !target.is('.share_icon')) {
       $('.share_wrapper .social_actions').hide();
    }
});

$('.template-product .thumbnail-slider .slider-button--prev').click(function(){
    event.preventDefault();
    let slider_count = $('ul.thumbnail-list>li').length;
  
    let parent_element = $('button.thumbnail[aria-current="true"]').parent();
    let slide_current_count = $(parent_element).attr('data-media-position');
    if(slide_current_count > 1){
      $(parent_element).find('button.thumbnail').removeAttr('aria-current')
      let prev_element = $(parent_element).prev();
      $(prev_element).find('button.thumbnail').trigger('click');
    }
})

$('.template-product .thumbnail-slider .slider-button--next').click(function(){
    event.preventDefault();

    let slider_count = $('ul.thumbnail-list>li').length;
  
    let parent_element = $('button.thumbnail[aria-current="true"]').parent();
    let slide_current_count = $(parent_element).attr('data-media-position');
    if(slide_current_count < slider_count){
      $(parent_element).find('button.thumbnail').removeAttr('aria-current');
      let next_element = $(parent_element).next();
      $(next_element).find('button.thumbnail').trigger('click');
    }    
})

$('.template-product .thumbnail-slider button.slider-button').removeAttr("disabled");

$('.readmoreDesc').click(function (event) {
  event.preventDefault();
  $('.product-description-full').css('display', 'block');
  $('.product-description-short').css('display', 'none');
  // var descriptionFull = document.querySelector('.product-description-full');
  // descriptionFull.style.display = 'block';
  // var descriptionShort = document.querySelector('.product-description-short');
  // descriptionShort.style.display = 'none';
});
$('.readlessDesc').click(function (event) {
  event.preventDefault();
  // var descriptionFull = document.querySelector('.product-description-full');
  // descriptionFull.style.display = 'none';
  // var descriptionShort = document.querySelector('.product-description-short');
  // descriptionShort.style.display = 'block';
  $('.product-description-full').css('display', 'none');
  $('.product-description-short').css('display', 'block');
});  

 // product page variants js start  
  $('.band_right_arrow').click(function() {
      event.preventDefault();
      $('.bs_options_wrapper').animate({
        scrollLeft: "+=200px"
      }, "slow");
   });
   
     $('.band_left_arrow').click(function() {
      event.preventDefault();
      $('.bs_options_wrapper').animate({
        scrollLeft: "-=200px"
      }, "slow");
   });

  $('.down_arrow').click(function() {
      event.preventDefault();
      $('.main_diamond_details').animate({
        scrollTop: "+=200px"
      }, "slow");
   });

  $('.up_arrow').click(function() {
      event.preventDefault();
      $('.main_diamond_details').animate({
        scrollTop: "-=200px"
      }, "slow");
   });
    // show variant values on load
    let init_clarity_val = $('input[option-name="product_option1"]:checked').val();
    let opt_attr_name = $('input[option-name="product_option1"]:checked').attr('name');
    let opt2_attr_name = $('input[option-name="product_option2"]:checked').attr('name');
    
    if(opt_attr_name != undefined && opt_attr_name.indexOf('Diamond')>0){
      init_clarity_val = init_clarity_val+" Diamond";
    }
    if(init_clarity_val != undefined && init_clarity_val.indexOf("/") > 0){
      let clarity_val_arr = init_clarity_val.split("/");
      let clt_val_1 = clarity_val_arr[0].replaceAll(" ", "");
      let clt_val_2 = clarity_val_arr[1].replaceAll(" ", "");
      init_clarity_val = clt_val_1;
      let gemstone_clarity = clt_val_2+" Diamond";
      $('#gemstone_clarity_selected').text(gemstone_clarity);
    }
    $('#clarity_selected').text(init_clarity_val);
    var init_metal_val = '';
    if(opt2_attr_name != undefined && opt2_attr_name.indexOf('Metal')>=0){
      init_metal_val = $('input[option-name="product_option2"]:checked').val();
      $('#metal_selected').text(init_metal_val);
      $('#caretWeight_selcted').css('display','none');
      $('#caretWeight_selcted+span').css('display','none');
    }else{
      let init_caret_val = $('input[option-name="product_option2"]:checked').val();
      init_metal_val = $('input[option-name="product_option3"]:checked').val();

      $('#caretWeight_selcted').text(init_caret_val);
      $('#metal_selected').text(init_metal_val);
      $('.variant_badge').text(init_caret_val);
    }
  
    let init_eng_font_val = $('input[name="eng_font_option"]:checked').val();
    let init_gift_card_price = $('input[name="Denomination"]:checked').val();
    let selected_var_id = $('.product input[name="id"]').val();

    if(init_metal_val != undefined && init_metal_val == 'Platinum'){
      // $('.show_selected_val #color_selected').css('display','none');
      // $('.variant_accordion_wrapper .color_variant_wrapper').css('display','none');
      // $('.platinum_metal_note').css("display","block");
      // $('.show_selected_val #color_selected').css('display','none');
      // $('.variant_accordion_wrapper .color_variant_wrapper').css('display','none');
      $('.show_selected_val #color_selected').css('display','block');
      $('.variant_accordion_wrapper .color_variant_wrapper').css('display','flex');
      $('.variant_accordion_wrapper .color_variant_wrapper .custom_color_hide').css('display','none');
      $('.variant_accordion_wrapper .color_variant_wrapper .custom_color_hide.platinum').css('display','block');
    }
   
    if(init_eng_font_val == 'Philosopher'){
      $('#engravingName').css('font-family', 'Ws-Philosopher');
    }
    if(init_eng_font_val == 'Allura'){
      $('#engravingName').css('font-family', 'Ws-Allura');
    }
    if(init_eng_font_val == 'Roboto'){
      $('#engravingName').css('font-family', 'Ws-Roboto');
    }
    $('.var_'+selected_var_id+'_ship_text').css('display','inline');
    
    $('#cardAmount_selcted').text(init_gift_card_price);

    if($('body').hasClass('natural-grown')){
      if($('.product-form form input[name="properties[_Diamond_Type]"]').length == 1){
          let val = $('input[option-name="product_option1"]:checked').val();
          let val_array = val.split("/");
          if(val_array[1].trim() == 'Lab Grown'){
            $('.product-form form input[name="properties[_Diamond_Type]"]').val("Lab-Grown");
          }
          if(val_array[1].trim() == 'Natural'){
            $('.product-form form input[name="properties[_Diamond_Type]"]').val("Natural");
          }
      }
    }
      
   // show variant values on change function
  $('input[option-name="product_option1"]').change(function(){
    $('.product_media_overlay').css('display','flex');
    let clarity_val = $(this).val();
    let opt_attr_name = $(this).attr('name');
    if(opt_attr_name.indexOf('Diamond')>0){
      clarity_val = clarity_val+" Diamond";
    }
    if(clarity_val.indexOf("/") > 0){
      let clarity_val_arr = clarity_val.split("/");
      let clt_val_1 = clarity_val_arr[0].replaceAll(" ", "");
      let clt_val_2 = clarity_val_arr[1].replaceAll(" ", "");
      clarity_val = clt_val_1;
      let gemstone_clarity = clt_val_2+" Diamond";
      $('#gemstone_clarity_selected').text(gemstone_clarity);
    }
    $('#clarity_selected').text(clarity_val);
    
    setTimeout(function(){
      let get_var_id = $('.product input[name="id"]').val();
      $('.pd_variant_ship_txt').css('display','none');
      $('.var_'+get_var_id+'_ship_text').css('display','inline');
      if($('body').hasClass('template-product-gift-card') != true){
        updateProductMediaSlider(get_var_id);
      }
      updateDynamicSpecis();
      setTimeout(function(){
        let variant_price = $('input[name="current_variant_price"]').val();
        console.log("price => ", variant_price)
        $('.addToCartPrice_text').text(variant_price);
        let get_price_num = variant_price.replace("$", "");
        if(get_price_num.includes(",")){
          get_price_num = get_price_num.replace(",", "");
        }
        get_price_num = parseInt(get_price_num);
       
             if(get_price_num >= 500){
              
            $('.prd_sale_text').css('display','block')
            //  $('.prd_sale_text .sale_discount_badge').css('display','none');
             $('.prd_sale_text .sale_2000_above').css('display','block')
          }
          // else if(get_price_num > 500 && get_price_num < 1500){            
          //    $('.prd_sale_text .sale_discount_badge').css('display','none');
          //    $('.prd_sale_text .sale_1000_above').css('display','block');
          //  }
           else{
             $('.prd_sale_text .sale_discount_badge').css('display','none');
            //  $('.prd_sale_text .sale').css('display','block')
             $('.prd_sale_text').css('display','none');
          }
      },1000);
    },2000);
  })
  $('input[option-name="product_option2"]').change(function(){
    $('.product_media_overlay').css('display','flex');
    let caret_val = $(this).val();
    let opt2_attr_name = $('input[option-name="product_option2"]:checked').attr('name');
    if(opt2_attr_name != undefined && opt2_attr_name.indexOf('Metal')>=0){
      $('#metal_selected').text(caret_val);
    }else{
      $('#caretWeight_selcted').text(caret_val);
      $('.variant_badge').text(caret_val);
    }
    
    // $('#caretWeight_selcted').text(caret_val);
    setTimeout(function(){
      let get_var_id = $('.product input[name="id"]').val();
      $('.pd_variant_ship_txt').css('display','none');
      $('.var_'+get_var_id+'_ship_text').css('display','inline');
      if($('body').hasClass('template-product-gift-card') != true){
        updateProductMediaSlider(get_var_id);
      }
      updateDynamicSpecis();
      setTimeout(function(){
        let variant_price = $('input[name="current_variant_price"]').val();
        console.log("price => ", variant_price)
        $('.addToCartPrice_text').text(variant_price);
        let get_price_num = variant_price.replace("$", "");
        if(get_price_num.includes(",")){
          get_price_num = get_price_num.replace(",", "");
        }
        get_price_num = parseInt(get_price_num);

        
             if(get_price_num >= 500){
              
            $('.prd_sale_text').css('display','block')
            //  $('.prd_sale_text .sale_discount_badge').css('display','none');
             $('.prd_sale_text .sale_2000_above').css('display','block')
          }
          // else if(get_price_num > 500 && get_price_num < 1500){            
          //    $('.prd_sale_text .sale_discount_badge').css('display','none');
          //    $('.prd_sale_text .sale_1000_above').css('display','block');
          //  }
           else{
             $('.prd_sale_text .sale_discount_badge').css('display','none');
            //  $('.prd_sale_text .sale').css('display','block')
             $('.prd_sale_text').css('display','none');
          }
      },1000);
    },2000);
  })
  $('input[option-name="product_option3"]').change(function(){
    $('.product_media_overlay').css('display','flex');
    let metal_val = $(this).val();
    $('#metal_selected').text(metal_val);
    if(metal_val != undefined && metal_val == 'Platinum'){
      // $('.show_selected_val #color_selected').css('display','none');
      // $('.variant_accordion_wrapper .color_variant_wrapper').css('display','none');
      // $('.platinum_metal_note').css("display","block");
      // let get_height = $('.vs_accordion.active + .vs_panel').prop('scrollHeight');
      // $('.vs_accordion.active + .vs_panel').css("max-height", get_height+"px");
        $('.show_selected_val #color_selected').css('display','block');
      $('.variant_accordion_wrapper .color_variant_wrapper').css('display','flex');
      $('.variant_accordion_wrapper .color_variant_wrapper .custom_color_hide').css('display','none');
      $('.variant_accordion_wrapper .color_variant_wrapper .custom_color_hide.platinum').css('display','block');
      $('.platinum_metal_note').css("display","block");
      // let get_height = $('.vs_accordion.active + .vs_panel').prop('scrollHeight');
      // $('.vs_accordion.active + .vs_panel').css("max-height", get_height+"px");
    }else{
      // $('.show_selected_val #color_selected').css('display','inline-block');
      // $('.variant_accordion_wrapper .color_variant_wrapper').css('display','flex');
      // $('.platinum_metal_note').css("display","none");
      // let get_height = $('.vs_accordion.active + .vs_panel').prop('scrollHeight');
      // $('.vs_accordion.active + .vs_panel').css("max-height", get_height+"px");
      $('.show_selected_val #color_selected').css('display','inline-block');
      $('.variant_accordion_wrapper .color_variant_wrapper').css('display','flex');
      $('.platinum_metal_note').css("display","none");
       $('.variant_accordion_wrapper .color_variant_wrapper .custom_color_hide').css('display','block');
      // let get_height = $('.vs_accordion.active + .vs_panel').prop('scrollHeight');
      // $('.vs_accordion.active + .vs_panel').css("max-height", get_height+"px");
    }
    setTimeout(function(){
      let get_var_id = $('.product input[name="id"]').val();
      $('.pd_variant_ship_txt').css('display','none');
      $('.var_'+get_var_id+'_ship_text').css('display','inline');
      if($('body').hasClass('template-product-gift-card') != true){
        updateProductMediaSlider(get_var_id);
      }
      updateDynamicSpecis();
      setTimeout(function(){
        let variant_price = $('input[name="current_variant_price"]').val();
        console.log("price => ", variant_price)
        $('.addToCartPrice_text').text(variant_price);
        let get_price_num = variant_price.replace("$", "");
        if(get_price_num.includes(",")){
          get_price_num = get_price_num.replace(",", "");
        }
        get_price_num = parseInt(get_price_num);

        
          if(get_price_num >= 500){
              
            $('.prd_sale_text').css('display','block')
            //  $('.prd_sale_text .sale_discount_badge').css('display','none');
             $('.prd_sale_text .sale_2000_above').css('display','block')
          }
          // else if(get_price_num > 500 && get_price_num < 1500){            
          //    $('.prd_sale_text .sale_discount_badge').css('display','none');
          //    $('.prd_sale_text .sale_1000_above').css('display','block');
          //  }
           else{
             $('.prd_sale_text .sale_discount_badge').css('display','none');
            //  $('.prd_sale_text .sale').css('display','block')
             $('.prd_sale_text').css('display','none');
          }
      },1000);
    },2000);
  })
  $('input[name="Denomination"]').change(function(){
    let gift_card_price_val = $(this).val();
    $('#cardAmount_selcted').text(gift_card_price_val);
    setTimeout(function(){
      let variant_price = $('input[name="current_variant_price"]').val();
      console.log("price => ", variant_price)
      $('.addToCartPrice_text').text(variant_price);
    },2000);
  })

  $('#verlasAddToCart').click(function(event){
    event.preventDefault();
    mainProductAddToCart();
  });
  $('#verlasStickyAddToCart').click(function(event){
    $(this).prop('disabled', true);
    event.preventDefault();
    mainProductAddToCart();
  });
  $('#engravingName').keyup(function(){
    let eng_val = $(this).val();
    let eng_val_length = eng_val.length;
    $('#eng_text_count').text(eng_val_length);
  });
  $('input[name="eng_font_option"]').change(function(){
    let font_name = $('input[name="eng_font_option"]:checked').val();
    if(font_name == 'Philosopher'){
      $('#engravingName').css('font-family', 'Ws-Philosopher');
    }
    if(font_name == 'Allura'){
      $('#engravingName').css('font-family', 'Ws-Allura');
    }
    if(font_name == 'Roboto'){
      $('#engravingName').css('font-family', 'Ws-Roboto');
    }
  })
 // product page variants js end

  // complete look product page slider
    var complete_look_slider = document.getElementById("completeLookSlider");
      //console.log(document.querySelector('#completeLookSlider .glide__slides').children.length);
      if (window.innerWidth > 767) {
        if (complete_look_slider && document.querySelector('#completeLookSlider .glide__slides').children.length > 3) {
          console.log("Glide.js initialized for Complete Look Slider.");
          // if (clientsReviewsSlider) {
            var completeGlide = new Glide(complete_look_slider, {
              type: "slider",
              focusAt: "0",
              hoverpause: true,
              autoplay: 3000,
              perView: 4,
              peek: {
                before: 0,
                after: 0
              },
              breakpoints: {
                800: {
                  perView: 2
                },
                500: {
                  perView: 2
                }
              }
            });
        }
      }else{
        if (complete_look_slider && document.querySelector('#completeLookSlider .glide__slides').children.length > 2) {
            var completeGlide = new Glide(complete_look_slider, {
              type: "slider",
              focusAt: "0",
              hoverpause: true,
              autoplay: 3000,
              perView: 4,
              peek: {
                before: 0,
                after: 0
              },
              breakpoints: {
                800: {
                  perView: 2
                },
                500: {
                  perView: 2
                }
              }
            });
        }
      }
      
      try {
        completeGlide.mount();
      } catch (error) {
        
      }

  
  // end complete look product page slider

  //  Get inspired product page slider
    var get_inspired_slider = document.getElementById("getInspiredSlider");
       
          var inspiredGlide = new Glide(get_inspired_slider, {
            type: "carousel",
            focusAt: "center",
            hoverpause: true,
            perView: 4,
            peek: {
              before: 0,
              after: 0
            },
            breakpoints: {
              800: {
                perView: 3
              },
              500: {
                perView: 1
              }
            }
          });
      try {
        inspiredGlide.mount();
      } catch (error) {
        
      }
  // end Get inspired product page slider

  // show shipping estimate date
   let get_ship_day = $('#metaShippingDay').val();
   if(get_ship_day != 'default'){
      var result = getDateAfterDays(get_ship_day);
      try {
        $('#shipping_date').text(result)
        $('#shippingDateProperty').val(result)
       
      } catch (error) {
       console.log("Error : ", error);
      }
   }

// Get metafield value from hidden span and convert to number
const metafieldDays = parseInt($('#cart_shipping_days').text(), 10);

// Validate and calculate date
if (!isNaN(metafieldDays)) {
  const today = new Date();
  
  // Add days from metafield
  today.setDate(today.getDate() + metafieldDays);

  // Format date to "Month Day"
  const options = { month: 'short', day: 'numeric' };
  const formattedDate = today.toLocaleDateString('en-US', options);

  // Insert into target element
  $('#cart_shipping_date').text(`by ${formattedDate}`);
  $('#maincart_shipping_date').text(`by ${formattedDate}`);
} else {
  console.error("Invalid metafieldDays value.");
}
  
  
  //  $('.metaShippingDay_default').each(function() {
  //      let get_ship_day = $(this).val();
  // console.log("get_ship_day => "+ get_ship_day);
  // if(get_ship_day != 'default'){
  //   // console.log("get_ship_day if"+get_ship_day);
  //  var result = getDateAfterDays(get_ship_day);
  //   try {
     
  //     // document.getElementById('shipping_date').innerHTML = result; 
  //     // document.querySelectorAll(".shipping_date_default").innerHTML = result; 
  //     var shippingDate = document.querySelectorAll(".shipping_date_default");
  //     shippingDate.forEach(function(element) {
  //         element.innerHTML = result;
  //     }); 
  //     $('#shippingDateProperty').val(result)
  //   } catch (error) {
     
  //   }
  // }
  //   });

  // show variant dynamic speciality value
  let get_variant_id = $('.template-product input[name="id"]').val();
  $('#pd_'+get_variant_id+'_specs').show();
  $('.pd_'+get_variant_id+'_cost').show();

  $(document).on('click', '.star-clickable', function(event){
     event.preventDefault(); 
      $('html, body').animate({
          scrollTop: $('#product-reviews-widget').offset().top-200
      }, 1000);
  });

  $(document).on('click', '.mobile_color_text.co_open_option', function(){
    let parent = $(this).parent();
    if(parent.hasClass('mobile_close')){
      parent.removeClass('mobile_close');
      if(parent.hasClass('mobile_open') == false){
        parent.addClass('mobile_open');
      }
    }
  });
  $(document).on('click', '.mobile_close_icon_wrap.co_close_option', function(){
    let parent = $(this).parent();
    if(parent.hasClass('mobile_open')){
      parent.removeClass('mobile_open');
      if(parent.hasClass('mobile_close') == false){
        parent.addClass('mobile_close');
      }
    }
  });

  $(document).on('click', '.remove_tah_kit_icon', function(){
    $('.tahKit_remove_modal').css("display","flex");
  });
  $(document).on('click', '.tk_close_modal', function(){
    $('.vs_custom_modal').css("display","none");
  });
  if (localStorage.getItem("drawer") == "open") {
    setTimeout(function() {
      $("#cart-icon-bubble")[0].click();
      window.history.pushState({}, '', new URL(window.location.origin+window.location.pathname));
    }, 1000);
    localStorage.setItem("drawer", "close")
  }

// ------- buy as gift js ------------

  $(document).on('click', '#buyAsGiftCTA', function(e){
    e.preventDefault();
    console.log("test");
    if($('.bs_options_wrapper').html() != undefined){
      let check_band_size = $('#bandSizeInput').val();
      console.log("=> ", check_band_size);
        if(check_band_size.length == 0){
          $('p.band_require_note').show();
          if($('.vs_accordion.band_size_ac').hasClass('active') != true){
            $('.vs_accordion.band_size_ac').trigger('click');  
          }
          $('html, body').animate({
            scrollTop: $("#bandSizeWrapper").offset().top-300
        }, 1000);
          $('#verlasStickyAddToCart').prop('disabled', false);
          return false;
        }
    }
    $('.gifthy_info_modal.vs_custom_modal').css('display','flex');
  });

// ------- end buy as gift js --------
  
});

function mainProductAddToCart(){
  if($('.bs_options_wrapper').html() != undefined){
    let check_band_size = $('#bandSizeInput').val();
    console.log("=> ", check_band_size);
    if(check_band_size.length == 0){
      $('p.band_require_note').show();
      if($('.vs_accordion.band_size_ac').hasClass('active') != true){
        $('.vs_accordion.band_size_ac').trigger('click');  
      }
      $('html, body').animate({
        scrollTop: $("#bandSizeWrapper").offset().top-300
    }, 1000);
      $('#verlasStickyAddToCart').prop('disabled', false);
      return false;
    }
  }
    let engraving_text = $('#engravingName').val();
    let engraving_font = $('input[name="eng_font_option"]:checked').val();
    $('#engravingInput').val(engraving_text);
    
    if(engraving_text != undefined && engraving_text.length > 0){
      $('#engravingFont').show();
      $('#engravingFont').val(engraving_font);
    }else{
      $('#engravingFont').hide();
    }
    setTimeout(function(){
      $('button.product-form__submit[name="add"]').trigger('click');
      $('#verlasStickyAddToCart').prop('disabled', false);
      let atcInterval = setInterval(function(){
        
        if($('cart-drawer').hasClass('active')){
          clearInterval(atcInterval);
          // checkFreeProduct();
        }
      },1000);
      
    },200);
}

// ----- gifthy buy as gift function 
async function buyAsGiftFunction() {
  $('.gifthy_error').css("display","none");
  $('.gifthy_action_wrap>.gifthy_act_btn').attr('disabled');
  let occasion = $('input[name="gifthy_occasion"]:checked').val();
  let from_email = $('#gifthy_from_email').val();
  let from_name = $('#gifthy_from_name').val();
  let to_email = $('#gifthy_to_email').val();
  let to_name = $('#gifthy_to_name').val();
  let gifthy_msg = $('#gifthy_message').val();
  console.log(from_email +" = "+ from_name +" = "+ to_email +" = "+ to_name + " | "+ gifthy_msg)
  if(from_email == '' || from_name == '' || to_email == '' || to_name == ''){
    $('.gifthy_error').css("display","block");
    $('.gifthy_action_wrap>.gifthy_act_btn').removeAttr('disabled');
    return false;
  }

  let input_html = `<div id="gifthyProperties">
      <input type="hidden" name="properties[gifthy_occasion]" value="`+occasion+`" />
        <input type="hidden" name="properties[gifthy_from_name]" value="`+from_name+`" />
        <input type="hidden" name="properties[gifthy_from_email]" value="`+from_email+`" />
        <input type="hidden" name="properties[gifthy_to_name]" value="`+to_name+`" />
        <input type="hidden" name="properties[gifthy_to_email]" value="`+to_email+`" />
        <input type="hidden" name="properties[gifthy_message]" value="`+gifthy_msg+`" />
  </div>`;

  $('.product-form input[name="id"]').after(input_html);
  
  await mainProductAddToCart();

  setTimeout(function(){
    $('.gifthy_error').css("display","none");
    $('.gifthy_action_wrap>.gifthy_act_btn').removeAttr('disabled');
     $('#gifthy_from_email').val('');
    $('#gifthy_from_name').val('');
     $('#gifthy_to_email').val('');
    $('#gifthy_to_name').val('');
    $('#gifthy_message').val('');
    $('#gifthyProperties').remove();
    $('.vs_custom_modal').css('display','none');
  }, 4000)
  
}

function scrollToTop() {
    window.scrollTo({
        top: 0,
        behavior: 'smooth'
    });
}

document.addEventListener('DOMContentLoaded', function() {
    const scrollToTopButton = document.getElementById('scrollToTopButton');
 
  if(scrollToTopButton != null){
    // Function to toggle button visibility
    function toggleScrollButton() {
        if (window.scrollY > window.innerHeight) {
            scrollToTopButton.style.display = 'flex';
        } else {
            scrollToTopButton.style.display = 'none';
        }
    }

    // Add event listener for scroll events
    window.addEventListener('scroll', toggleScrollButton);

    // Add event listener for button click
    scrollToTopButton.addEventListener('click', scrollToTop);
  }
});
function isMobile() {
  // Check the user agent string
  const userAgent = navigator.userAgent;
  return /Mobile|Android|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(userAgent);
}

function isDesktop() {
  // Check the user agent string
  return !isMobile();
}
document.addEventListener('DOMContentLoaded', function() {
    // const stickyBuyButton =  document.getElementById('verlasStickyAddToCart'); //$('.template-product #verlasStickyAddToCart');
 const stickyBuyButton =  document.getElementById('verlasStickyAddToCartWrapper');
  if(stickyBuyButton != null){
    if(isDesktop())
      var innerHeightMultiplier = 1;
    else
      var innerHeightMultiplier = 1.5;
    // Function to toggle button visibility
    function toggleStickyButton() {
        if (window.scrollY > (window.innerHeight*innerHeightMultiplier)) {
            stickyBuyButton.style.display = 'flex';
        } else {
            stickyBuyButton.style.display = 'none';
        }
    }

    // Add event listener for scroll events
    window.addEventListener('scroll', toggleStickyButton);

    // Add event listener for button click
    // scrollToTopButton.addEventListener('click', scrollToTop);
  }
});


function getDateAfterDays(days) {
  var currentDate = new Date();
  var targetDate = new Date(currentDate.getTime() + (days * 24 * 60 * 60 * 1000));
  
  var months = ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'];
  var month = months[targetDate.getMonth()];
  var day = targetDate.getDate();

  return month + ' ' + day;
}

$('.product-form__submit[name="add"] span').on('DOMSubtreeModified',function(){
  let add_text = $('.product-form__submit[name="add"] span').text();
  console.log("text => ", add_text);
  $('#verlasAddToCart .addToCartTitle_text').text(add_text);
  $('#verlasStickyAddToCart .addToCartTitle_text').text(add_text);
  if($('.product-form__submit[name="add"]').is('[disabled]') == true){
    console.log("checked attribute")
    $('#verlasAddToCart').attr('disabled','disabled');
    $('#verlasStickyAddToCart').attr('disabled','disabled');
  }else{
    if($('#verlasAddToCart').is('[disabled]') == true){
      $('#verlasAddToCart').removeAttr('disabled');
    }
    if($('#verlasStickyAddToCart').is('[disabled]') == true){
      $('#verlasStickyAddToCart').removeAttr('disabled');
    }
  }
});

// function updateAddToCartText(){
//   let add_text = $('.product-form__submit[name="add"] span').text();
//   console.log("text => ", add_text);
//   $('#verlasAddToCart>span').text(add_text);
//   if($('.product-form__submit[name="add"]').is('[disabled]') == true){
//     console.log("checked attribute")
//     $('#verlasAddToCart').attr('disabled','disabled');
//   }else{
//     if($('#verlasAddToCart').is('[disabled]') == true){
//       $('#verlasAddToCart').removeAttr('disabled');
//     }
//   }
// }

// show variants dynamic species
function updateDynamicSpecis(){
    let get_variant_id = $('.template-product input[name="id"]').val();
    // console.log('var =>', get_variant_id);
    $('.pdp_speciality_section').css('display','none')
    $('.vs_dynamic_cost').css('display','none')
    $('#pd_'+get_variant_id+'_specs').css('display','block');
    $('.pd_'+get_variant_id+'_cost').css('display','block')
    if($('.vs_accordion.active').hasClass('diamond_ac')){
      let get_height = $('.vs_accordion.active + .vs_panel').prop('scrollHeight');
      $('.vs_accordion.active + .vs_panel').css("max-height", get_height+"px");
    }
  if($('body').hasClass('natural-grown')){
    let diamond_type_val = $('#pd_'+get_variant_id+'_specs .diamond_type_wrapper .specs_value').text();
    if($('.product-form form input[name="properties[_Diamond_Type]"]').length == 1){
      console.log("diamond_type_val : ", diamond_type_val)
      if(diamond_type_val != ""){
        $('.product-form form input[name="properties[_Diamond_Type]"]').val(diamond_type_val);
      }else{
        let val = $('input[option-name="product_option1"]:checked').val();
        let val_array = val.split("/");
        if(val_array[1].trim() == 'Lab Grown'){
          $('.product-form form input[name="properties[_Diamond_Type]"]').val("Lab-Grown");
        }
        if(val_array[1].trim() == 'Natural'){
          $('.product-form form input[name="properties[_Diamond_Type]"]').val("Natural");
        }
      }
    }
  }
}

function qckChangeBandSize(product_id, ring_size){
  $('.qck_'+product_id+'_wrap p.band_require_note').hide();
  if($('.qck_'+product_id+'_wrap span.band_size_val').hasClass('active')){
    $('.qck_'+product_id+'_wrap span.band_size_val').removeClass('active');
  }
  $('.qck_'+product_id+'_wrap .band_size_val[data-val="'+ring_size+'"]').addClass('active');
  $('#bandSize_selected_'+product_id).text(ring_size);
}

function changeBandSize(ring_size){
  $('p.band_require_note').hide();
  if($('span.band_size_val').hasClass('active')){
    $('span.band_size_val').removeClass('active');
  }
  $('.band_size_val[data-val="'+ring_size+'"]').addClass('active');
  $('#bandSize_selected').text(ring_size);
  $('#bandSizeInput').val(ring_size);
  $('#bandSizeWrapper .band_size_unit').css('display','inline');
}

function setProdImageHoverListeners(){
  $(document).find(".product-card-wrapper .card--media .card__inner .card__content").mouseenter(function(){
    if($(this).parent().find('.card__media #colorImages img.active + img.color-img-hover').length > 0){
      $(this).parent().find('.card__media #colorImages img.active').hide();
      $(this).parent().find('.card__media #colorImages img.active + img.color-img-hover').show();
    }
  });

  $(document).find(".product-card-wrapper .card--media .card__inner .card__content").mouseleave(function(){
    if($(this).parent().find('.card__media #colorImages img.active + img.color-img-hover').length > 0){
      $(this).parent().find('.card__media #colorImages img.active').show();
      $(this).parent().find('.card__media #colorImages img.active + img.color-img-hover').hide();
    }
  }); 
}  

// change image on card product variant option
function changeProductColorImage(product_id, color) {
  console.log("product id => ", product_id, " | color : ", color);

  let productContainer = $('#pd_' + product_id + '_images');

  // Remove active class from all product images
  productContainer.find('.product-image').removeClass('active').hide();

  // Add active class to selected color variant
  let activeImage = productContainer.find('.product-image.' + color + '_images');
  if (activeImage.length) {
    activeImage.addClass('active').show();
  } else {
    console.error("No matching color variant found for: ", color);
    return;
  }

  // Remove active class from all color options
  $('#pd_' + product_id + '_colorOption .color_option').removeClass('active');

  // Add active class to selected color option
  $('#pd_' + product_id + '_colorOption .color_option.' + color + '_option').addClass('active');

  // Reinitialize Swiper for the new color variant
  reinitializeSwiper(product_id, color);
}
// document.addEventListener("DOMContentLoaded", function () {
//   initializeFirstSwiper();
// });

function initializeFirstSwipers() {
  $('.product-image.active .swiper').each(function () {
    let swiperContainer = $(this);

    if (!swiperContainer.length) return;

    let newSwiper = new Swiper(swiperContainer.get(0), {
      slidesPerView: 1,
      loop: true,
      spaceBetween: 8,
      pagination: {
      el: '.swiper-pagination',
      clickable: true, // Allows clicking on dots to navigate
    },
    });
console.log(newSwiper);
    // Store Swiper instance on the container
    swiperContainer.data('swiper', newSwiper);
  });
}

// Run on page load
$(document).ready(function () {
  initializeFirstSwipers();
});


function reinitializeSwiper(product_id, color) {
  let swiperContainer = $('#pd_' + product_id + '_images .product-image.' + color + '_images .swiper');

  if (!swiperContainer.length) {
    console.error("Swiper container not found for color: ", color);
    return;
  }

  // Destroy previous Swiper instance if exists
  if (swiperContainer.data('swiper')) {
    swiperContainer.data('swiper').destroy(true, true);
  }

  // Initialize new Swiper instance
   let newSwiper = new Swiper(swiperContainer.get(0), {
      slidesPerView: 1,
      loop: true,
      spaceBetween: 8,
      pagination: {
      el: '.swiper-pagination',
      clickable: true, // Allows clicking on dots to navigate
    },
    });

  // Store Swiper instance on the container
  swiperContainer.data('swiper', newSwiper);
  console.log("Swiper container:", swiperContainer);

}
// change all products color js on collection page
function changeAllProductsColor(color_val, color_id){
  console.log(" color name =< ", color_val);
  // if($('ul#product-grid').hasClass('filter_products') == false){
  //   $('ul#product-grid').addClass('filter_products');
  // }

  let search_param = window.location.search;
  let new_filtre_val = '';
  if(window.location.search.indexOf("product_color") == -1){
    search_param = search_param.replace("?","");
    if(search_param != ''){
      new_filtre_val = search_param+"&filter.p.m.custom.product_color="+color_val;
    }else{
      new_filtre_val = "filter.p.m.custom.product_color="+color_val;
    }
  }else{
    search_param = search_param.replace("?","");
    let param_array = search_param.split("&");
    for(var i=0;i<param_array.length;i++){
      if(param_array[i].indexOf("product_color") >= 0){
        if(i == 0){
          new_filtre_val += "filter.p.m.custom.product_color="+color_val;
        }else{
          new_filtre_val += "&filter.p.m.custom.product_color="+color_val;
        }
        
      }else{
        if(i == 0){
          new_filtre_val += param_array[i];
        }else{
          new_filtre_val += "&"+param_array[i];
        }
      }
    }
  }

  console.log("filter url val => " , new_filtre_val)
  customElements.get("facet-filters-form").renderPage(new_filtre_val)
  
  $('.color_flt_option_wrapper .color_filter_option').removeClass('selected');
  $('#'+color_id).addClass('selected');
  if($('ul#product-grid').hasClass('filter_products') == false){
    $('ul#product-grid').addClass('filter_products');
  }

  // let color_txt = color_val.toLowerCase();

  // console.log(" color name =< ", color_txt);
  
  // $('ul#product-grid>li.cl_'+color_txt+'_product').css('display','block');
}

// open quick view product popup
function quickAddPopup(product_handle){  
  $('.quick_product_modal').show();
  $('.quick_view_overlay').css('display','flex');
  
  let url_handle = "/products/"+product_handle+".json";
    $.ajax({
        url: url_handle,
    }).done(function (data, xhr) {
      let title = data.product.title;
      let price = Shopify.formatMoney(data.product.variants[0].price, 'amount_no_decimals');
      var qck_product = data.product;
      const qck_prd_color = $('#pd_'+qck_product.id+'_color').val();
      let options = qck_product.options;
      let band_meta_al = $('#pd_'+qck_product.id+'_band').val();
      let band_size_array = band_meta_al.split("|");
      let band_size_array_length = band_size_array.length;
     
      
      var diamond_clarity_html = ``;
      var diamond_caret_html = ``;
      var metal_html = ``;
      var other_options = ``;
      var band_size_html = ``;
      var variant_option_html = ``;
      var band_section_wrapper = ``;
      
      let variants = qck_product.variants;
      for(var a=0; a<variants.length; a++){
      	if(a==0){
      		variant_option_html += `<option value="`+variants[a].id+`" data-option1="`+variants[a].option1+`" data-option2="`+variants[a].option2+`" data-option3="`+variants[a].option3+`" data-price="`+variants[a].price+`"  selected >`+variants[a].title+`</option>`;
      	}else{
      		variant_option_html += `<option value="`+variants[a].id+`" data-option1="`+variants[a].option1+`" data-option2="`+variants[a].option2+`" data-option3="`+variants[a].option3+`" data-price="`+variants[a].price+`"  >`+variants[a].title+`</option>`;
      	}
      	
      }
      var eng_tab_number = '4';
      if(band_meta_al == ''){
        eng_tab_number = '3';
        // for (var i = 4.0; i <= 13.5; i += 0.5){
        //     band_size_html += `<span class="band_size_val" data-val="`+i+`" onclick="qckChangeBandSize('`+qck_product.id+`','`+i+`')">`+i+`</span>`;
        // } 
      }else{
        // let split_band_val = band_meta_al.split('-');
        // // let band_start = parseFloat(split_band_val[0]).toFixed(1);
        // // let band_end = parseFloat(split_band_val[1]).toFixed(1);
        //  let band_start = parseInt(split_band_val[0]);
        // let band_end = parseInt(split_band_val[1]);
        // console.log("split_band_val => ", band_start, " | ", band_end);
        // for (var i = band_start; i <= band_end; i += 0.5){
        //     band_size_html += `<span class="band_size_val" data-val="`+i+`" onclick="qckChangeBandSize('`+qck_product.id+`','`+i+`')">`+i+`</span>`;
        // } 
        for (var i = 0; i < band_size_array_length; i++){
          band_size_html += `<span class="band_size_val" data-val="`+band_size_array[i]+`" onclick="qckChangeBandSize('`+qck_product.id+`','`+band_size_array[i]+`')">`+band_size_array[i]+`</span>`;
        }

        band_section_wrapper = `<!-- Band size option -->
          <div class="accordion_wrap" id="bandSizeWrapper_`+qck_product.id+`">
            <button class="pd_variant_accordion vs_accordion band_size_ac"><span class="count_txt"></span>Band Size <sup>*</sup>
              <span class="show_selected_val">
                <span id="bandSize_selected_`+qck_product.id+`">Choose Option</span>
              </span>
            </button>
            <div class="vs_panel band_size_panel">
              <p class="band_require_note">Please select a band size.</p>
              <button class="band_arrows band_left_arrow">
                <span class="arrow-icon"></span>
              </button>
              <div class="bs_options_wrapper">
                  `+band_size_html+`
                </div>
                <button class="band_arrows band_right_arrow">
                  <span class="arrow-icon"></span>
                </button>
            </div>
          </div>`;
        
      }
      console.log("band_size_html => ", band_size_html)
      
      for(var a=0; a<options.length; a++){
      	if(options[a].name == 'Choose Diamond Clarity' || options[a].name == 'Choose Primary Stone'){
      		diamond_clarity_html += `<div class="qck_variant_options_wrap">
      							<label class="qck_option_name">`+options[a].name+`</label>`;
      		let options_valus = options[a].values;
      		for(let j=0; j<options_valus.length; j++){
                if(j==0){
                  diamond_clarity_html += `<div class="qck_variant_option">
      						<input type="radio" name="qck_option`+a+`" onchange="qckVariantUpdate('`+qck_product.id+`')" value="`+options_valus[j]+`" checked/>
      					<span>`+options_valus[j]+`</span>
      				</div>`;
                }else{
                  diamond_clarity_html += `<div class="qck_variant_option">
      						<input type="radio" name="qck_option`+a+`" value="`+options_valus[j]+`" onchange="qckVariantUpdate('`+qck_product.id+`')" />
      					<span>`+options_valus[j]+`</span>
      				</div>`;
                }
      		}
      		diamond_clarity_html += `</div>`
      	}
      	else if(options[a].name == 'Choose Carat Weight' || options[a].name == 'Choose Primary Stone Dimensions'){
      		diamond_caret_html += `<div class="qck_variant_options_wrap">
      							<label class="qck_option_name">`+options[a].name+`</label>`;
      
      		let options_valus = options[a].values;
      		for(let j=0; j<options_valus.length; j++){
                if(j==0){
                  diamond_caret_html += `<div class="qck_variant_option">
      						<input type="radio" name="qck_option`+a+`" value="`+options_valus[j]+`" onchange="qckVariantUpdate('`+qck_product.id+`')" checked />
      					<span>`+options_valus[j]+`</span>
      				</div>`;
                }else{
                  diamond_caret_html += `<div class="qck_variant_option">
      						<input type="radio" name="qck_option`+a+`" value="`+options_valus[j]+`" onchange="qckVariantUpdate('`+qck_product.id+`')" />
      					<span>`+options_valus[j]+`</span>
      				</div>`;
                }
      			
      		}
      		diamond_caret_html += `</div>`;
      	}
      	else if(options[a].name == 'Choose Metal Type'){
      		metal_html += `<div class="qck_variant_options_wrap">
      							<label class="qck_option_name">`+options[a].name+`</label>`;
      		let options_valus = options[a].values;
      		for(let j=0; j<options_valus.length; j++){
              if(j==0){
                metal_html += `<div class="qck_variant_option">
        				<input type="radio" name="qck_option`+a+`" value="`+options_valus[j]+`" checked onchange="qckVariantUpdate('`+qck_product.id+`')" />
      					<span>`+options_valus[j]+`</span>
      				</div>`;
              }else{
                metal_html += `<div class="qck_variant_option">
      						<input type="radio" name="qck_option`+a+`" value="`+options_valus[j]+`" onchange="qckVariantUpdate('`+qck_product.id+`')" />
      					<span>`+options_valus[j]+`</span>
      				</div>`;
              }
      			
      		}
      		metal_html += `</div>`;
      	}
      	else {
      		other_options += `<div class="qck_variant_options_wrap">
      							<label class="qck_option_name">`+options[a].name+`</label>`;
      		let options_valus = options[a].values;
      		let opt_name = options[a].name.replaceAll(' ','_')
      		for(let j=0; j<options_valus.length; j++){
              if(j==0){
                other_options += `<div class="qck_variant_option">
      						<input type="radio" name="qck_option`+a+`" value="`+options_valus[j]+`" checked onchange="qckVariantUpdate('`+qck_product.id+`')" />
      					<span>`+options_valus[j]+`</span>
      				</div>`;
              }else{
                other_options += `<div class="qck_variant_option">
      						<input type="radio" name="qck_option`+a+`" value="`+options_valus[j]+`" onchange="qckVariantUpdate('`+qck_product.id+`')" />
      					<span>`+options_valus[j]+`</span>
      				</div>`;
              }
      		}
      		other_options += `</div>`;
      	}
      }

      let modal_html = `<div class="qck_product_image">
        <img src="`+qck_product.image.src+`" />
      </div>
      <div class="qck_product_content qck_`+qck_product.id+`_wrap">
        <div class="qck_product_info">
          <h2>`+title+`</h2>
          <div class="qck_pd_price">
            <span>`+price+`</span>
          </div>
          <div class="variant_accordion_wrapper">
          <div class="variant_heading_wrap">
            <h4>CUSTOMIZE</h4>
            <small class="note_txt">* Required Field</small>
          </div>
          
          <!-- Diamond accordian -->
          <div class="accordion_wrap">
            <button class="pd_variant_accordion vs_accordion diamond_ac"><span class="count_txt">1</span> Diamond
            <span class="show_selected_val">
              <span id="caretWeight_selcted_`+qck_product.id+`">`+qck_product.variants[0].option2+`</span>
              <span>, </span>
              <span id="clarity_selected_`+qck_product.id+`">`+qck_product.variants[0].option1+` Diamond</span>
            </span>
            </button>
            <div class="vs_panel">
              `+diamond_clarity_html+`
              `+diamond_caret_html+`
            </div>
          </div>
          <!-- Metal accordian -->
          <div class="accordion_wrap">
            <button class="pd_variant_accordion vs_accordion"><span class="count_txt">2</span> Metal
              <span class="show_selected_val">
                <span id="metal_selected_`+qck_product.id+`">`+qck_product.variants[0].option3+`</span>
              </span>
            </button>
            <div class="vs_panel">
                 `+metal_html+`
                `+other_options+`     
            </div>
          </div>
          `+band_section_wrapper+`

          <!-- Engraving option -->
          <div class="accordion_wrap">
            <button class="pd_variant_accordion vs_accordion"><span class="count_txt">`+eng_tab_number+` </span>Engraving
              <span class="show_selected_val">
                <span id="engraving_selected">Optional</span>
              </span>
            </button>
            <div class="vs_panel">
              <div class="pd_engraving_content_wrap">
                <div class="engraving_input_wrap">
                  <label>Your message</label>
                  <input type="text" class="custom_engraving_input" id="engravingName_`+qck_product.id+`" maxlength="18" Placeholder="Your Message" />
                  <span class="eng_text_length">
                    <span id="eng_text_count`+qck_product.id+`">0</span>
                    <span class="eng_total_count"> / 18</span>
                  </span>
                </div>
                <div class="eng_font_wrapper">
                  <span class="eng_input_font">
                    <input type="radio" name="qck_font_`+qck_product.id+`" checked value="Philosopher" />
                    <span class="font_name" style="font-family: 'Ws-Philosopher';">Serif</span>
                  </span>
                  <span class="eng_input_font">
                    <input type="radio" name="qck_font_`+qck_product.id+`" value="Allura" />  
                    <span class="font_name" style="font-family: 'Ws-Allura';">Script</span>
                  </span>
                  <span class="eng_input_font">
                    <input type="radio" name="qck_font_`+qck_product.id+`" value="Roboto" />
                    <span class="font_name" style="font-family: 'Ws-Roboto';">Sans-serif</span>
                  </span>
                </div>
                <p style="font-style: italic;"><small>*Return shipping not included on engraved items</small></p>
              </div>
            </div>
          </div>
          
        </div>
        </div>
        
        <div class="action_wrap">
          <select style="display:none" id="quickProductId_`+data.product.id+`">`+variant_option_html+`</select>
       <!--   <input type="hidden" id="quickProductId_`+data.product.id+`" value="`+data.product.variants[0].id+`" /> -->
          <button class="button quick_add_to_cart" onclick="quickAddProductAjax(`+data.product.id+`, '`+qck_prd_color+`')">
            <span>Add To Bag</span>
            <span id="qck_`+data.product.id+`_price" class="qck_atc_price" >`+price+`</span>
          </button>
          <a href="/products/`+data.product.handle+`" class="prd_detail_link">See Product Details</a>
        </div>
      </div>`;
      $('.quick_product_content').html(modal_html);
      $('.quick_view_overlay').css('display','none');
        setTimeout(function name(params) {
            // js code for accordions
            var acc = document.getElementsByClassName("vs_accordion");
            var i;
            
            for (i = 0; i < acc.length; i++) {
              acc[i].addEventListener("click", function() {
                var panel = this.nextElementSibling;
                var isActive = this.classList.contains("active");
                
                // Close all panels
                for (var j = 0; j < acc.length; j++) {
                  acc[j].classList.remove("active");
                  acc[j].nextElementSibling.style.maxHeight = null;
                }
                
                // Toggle the clicked panel
                if (!isActive) {
                  this.classList.toggle("active");
                  panel.style.maxHeight = panel.scrollHeight + "px";
                }
              });
            }
          // end js code for accordions

          $('.band_right_arrow').click(function() {
              event.preventDefault();
              $('.bs_options_wrapper').animate({
                scrollLeft: "+=200px"
              }, "slow");
           });
           
             $('.band_left_arrow').click(function() {
              event.preventDefault();
              $('.bs_options_wrapper').animate({
                scrollLeft: "-=200px"
              }, "slow");
           });

            $('#engravingName_'+qck_product.id).keyup(function(){
              let eng_val = $(this).val();
              let eng_val_length = eng_val.length;
              $('#eng_text_count'+qck_product.id).text(eng_val_length);
            });
            $('input[name="qck_font_'+qck_product.id+'"]').change(function(){
              let font_name = $('input[name="qck_font_'+qck_product.id+'"]:checked').val();
              if(font_name == 'Philosopher'){
                $('#engravingName_'+qck_product.id).css('font-family', 'Ws-Philosopher');
              }
              if(font_name == 'Allura'){
                $('#engravingName_'+qck_product.id).css('font-family', 'Ws-Allura');
              }
              if(font_name == 'Roboto'){
                $('#engravingName_'+qck_product.id).css('font-family', 'Ws-Roboto');
              }
            })
          
        },1000);
        //success
    }).fail(function (err, xhr){
        console.log("error => ", err);
    });

  
}

// open quick view Tah product popup
function quickTAHAddPopup(product_handle){  
  $('.quick_product_modal').show();
  $('.quick_view_overlay').css('display','flex');
  
  let url_handle = "/products/"+product_handle+".json";
    $.ajax({
        url: url_handle,
    }).done(function (data, xhr) {
      let title = data.product.title;
      let price = Shopify.formatMoney(data.product.variants[0].price);
      
      var qck_product = data.product;
      const tah_qck_prd_color = $('#pd_'+qck_product.id+'_color').val();
      let options = qck_product.options;
      let band_meta_al = $('#pd_'+qck_product.id+'_band').val();
      let band_size_array = band_meta_al.split("|");
      let band_size_array_length = band_size_array.length;
      let carat_weight_meta = $('#pd_'+qck_product.id+'_caratWeight').val();
      let caret_weight_array = carat_weight_meta.split(",");
      let caret_weight_array_length = caret_weight_array.length;
      console.log("carat_weight_meta => ", carat_weight_meta)
      
      // var diamond_clarity_html = ``;
      var diamond_caret_html = ``;
      // var metal_html = ``;
      // var other_options = ``;

      for (var i = 0; i < caret_weight_array_length; i++){
        if(i == 0){
            diamond_caret_html += `<span class="pd_var_option">
                       <input type="radio" name="tah_`+qck_product.id+`_carat_weight" checked value="`+caret_weight_array[i]+`" />
                       <span class="var_option_txt">`+caret_weight_array[i]+`</span>
                    </span>`;
        }else{
          diamond_caret_html += `<span class="pd_var_option">
                       <input type="radio" name="tah_`+qck_product.id+`_carat_weight" value="`+caret_weight_array[i]+`" />
                       <span class="var_option_txt">`+caret_weight_array[i]+`</span>
                    </span>`;
        }
      } 
      
      var variant_option_html = ``;
      let product_variants = {};
      let variants = qck_product.variants;
      for(var a=0; a<variants.length; a++){
        let opt_name = variants[a].option1.replace(" ","");
        product_variants[opt_name] = variants[a].id;
      	if(a==0){
      		variant_option_html += `<option value="`+variants[a].id+`" data-option1="`+variants[a].option1+`" data-option2="`+variants[a].option2+`" data-option3="`+variants[a].option3+`" data-price="`+variants[a].price+`"  selected >`+variants[a].title+`</option>`;
      	}else{
      		variant_option_html += `<option value="`+variants[a].id+`" data-option1="`+variants[a].option1+`" data-option2="`+variants[a].option2+`" data-option3="`+variants[a].option3+`" data-price="`+variants[a].price+`"  >`+variants[a].title+`</option>`;
      	}
      	
      }
      let str_product_variants = JSON.stringify(product_variants);
      console.log("before btoa => ", str_product_variants);
      str_product_variants = btoa(str_product_variants);
      console.log("after btoa => ", str_product_variants);
      
      var band_size_html = ``;
      var band_section_wrapper = ``;
      

      if(band_meta_al == ''){
        
      }else{
        // let split_band_val = band_meta_al.split('-');
        //  let band_start = parseInt(split_band_val[0]);
        // let band_end = parseInt(split_band_val[1]);
        // console.log("split_band_val => ", band_start, " | ", band_end);
        // for (var i = band_start; i <= band_end; i += 0.5){
        //     band_size_html += `<span class="band_size_val" data-val="`+i+`" onclick="qckChangeBandSize('`+qck_product.id+`','`+i+`')">`+i+`</span>`;
        // } 

        for (var i = 0; i < band_size_array_length; i++){
          band_size_html += `<span class="band_size_val" data-val="`+band_size_array[i]+`" onclick="qckChangeBandSize('`+qck_product.id+`','`+band_size_array[i]+`')">`+band_size_array[i]+`</span>`;
        } 
        
        band_section_wrapper = `<!-- Band size option -->
          <div class="accordion_wrap" id="bandSizeWrapper_`+qck_product.id+`">
            <button class="pd_variant_accordion vs_accordion band_size_ac"><span class="count_txt">2 </span>Band Size <sup>*</sup>
              <span class="show_selected_val">
                <span id="bandSize_selected_`+qck_product.id+`">Choose Option</span>
              </span>
            </button>
            <div class="vs_panel band_size_panel">
              <p class="band_require_note">Please select a band size.</p>
              <button class="band_arrows band_left_arrow">
                <span class="arrow-icon"></span>
              </button>
              <div class="bs_options_wrapper">
                  `+band_size_html+`
                </div>
                <button class="band_arrows band_right_arrow">
                  <span class="arrow-icon"></span>
                </button>
            </div>
          </div>`;
      }
      console.log("band_size_html => ", band_size_html)

      let modal_html = `<div class="qck_product_image">
        <img src="`+qck_product.image.src+`" />
      </div>
      <div class="qck_product_content qck_`+qck_product.id+`_wrap">
        <div class="qck_product_info">
          <h2>`+title+`</h2>
          <div class="tah_replica_tag">
                          <span>Replica</span>
                        </div>
           <p class="pd_tah_label">(Try-at-Home)</p>             
          <div class="variant_accordion_wrapper">
          <div class="variant_heading_wrap">
            <h4>CUSTOMIZE</h4>
            <small class="note_txt">* Required Field</small>
          </div>
          
          <!-- Diamond accordian -->
          <div class="accordion_wrap">
            <button class="pd_variant_accordion vs_accordion diamond_ac"><span class="count_txt">1</span> Cubic Zirconia
            <span class="show_selected_val">
              <span id="caretWeight_selcted_`+qck_product.id+`">`+caret_weight_array[0]+`</span>
            </span>
            </button>
            <div class="vs_panel">
              <div class="tah_pd_options option2_wrap">
                <label class="form__label">TOTAL CARAT WEIGHT</label>
                <div class="pd_var_option_wrapper">
                 `+diamond_caret_html+`
                 </div>
              </div>
            </div>
          </div>

          `+band_section_wrapper+`
          
        </div>
        </div>
        
        <div class="action_wrap">
          <select style="display:none" id="quickProductId_`+data.product.id+`">`+variant_option_html+`</select>
       <!--   <input type="hidden" id="quickProductId_`+data.product.id+`" value="`+data.product.variants[0].id+`" /> -->
            <button class="button quick_add_to_cart" onclick='quickTAHAddProductAjax(`+data.product.id+`, "`+str_product_variants+`", "`+tah_qck_prd_color+`")'>
            <span>Add To Bag</span>
            </button> 
          <a href="/products/`+data.product.handle+`" class="prd_detail_link">See Product Details</a>
        </div>
      </div>`;
      $('.quick_product_content').html(modal_html);
      $('.quick_view_overlay').css('display','none');
        setTimeout(function name(params) {
            // js code for accordions
            var acc = document.getElementsByClassName("vs_accordion");
            var i;
            
            for (i = 0; i < acc.length; i++) {
              acc[i].addEventListener("click", function() {
                var panel = this.nextElementSibling;
                var isActive = this.classList.contains("active");
                
                // Close all panels
                for (var j = 0; j < acc.length; j++) {
                  acc[j].classList.remove("active");
                  acc[j].nextElementSibling.style.maxHeight = null;
                }
                
                // Toggle the clicked panel
                if (!isActive) {
                  this.classList.toggle("active");
                  panel.style.maxHeight = panel.scrollHeight + "px";
                }
              });
            }
          // end js code for accordions

          $('.band_right_arrow').click(function() {
              event.preventDefault();
              $('.bs_options_wrapper').animate({
                scrollLeft: "+=200px"
              }, "slow");
           });
           
             $('.band_left_arrow').click(function() {
              event.preventDefault();
              $('.bs_options_wrapper').animate({
                scrollLeft: "-=200px"
              }, "slow");
           });
          $('input[name="tah_'+qck_product.id+'_carat_weight"]').change(function(){
            // $('.product_media_overlay').css('display','flex');
            let caret_val = $(this).val();
            $('#caretWeight_selcted_'+qck_product.id).text(caret_val);
          })
          
        },1000);
        //success
    }).fail(function (err, xhr){
        console.log("error => ", err);
    });
}

function qckVariantUpdate(product_id){
  let option1_val = $('.qck_'+product_id+'_wrap input[name="qck_option0"]:checked').val();
  let option2_val = $('.qck_'+product_id+'_wrap input[name="qck_option1"]:checked').val();
  let option3_val = $('.qck_'+product_id+'_wrap input[name="qck_option2"]:checked').val();

  $('#clarity_selected_'+product_id).text(option1_val+' Diamond');
  $('#caretWeight_selcted_'+product_id).text(option2_val);
  $('#metal_selected_'+product_id).text(option3_val);

  console.log("option 1 => ",option1_val , " | option 2 => ", option2_val , " | option 3 => ", option3_val );
  $('#quickProductId_'+product_id+' option').filter(function() {
          if($(this).attr('data-option1') === option1_val && $(this).attr('data-option2') === option2_val && $(this).attr('data-option3') === option3_val){
            let price = Shopify.formatMoney($(this).attr('data-price'));
            $('.qck_'+product_id+'_wrap .qck_pd_price span').text(price);
            $('#qck_'+product_id+'_price').text(price);
            return $(this);
          }
  }).prop('selected', true);
  
}

function closeQuickModal(){
  $('.quick_product_modal').hide();
  $('.quick_product_content').html('');
}

function quickTAHAddProductAjax(product_id, pd_variants, pd_color){
   $('.quick_view_overlay').css('display','flex');
    let product_variants = JSON.parse(atob(pd_variants));
    let getCarat_weight = $('input[name="tah_'+product_id+'_carat_weight"]:checked').val();
    // let shipping_date = $('#shippingDateProperty').val();
    // var pd_property = {'_Carat_Weight':getCarat_weight, '_bundle_ids':product_variants, '_shipping_data':shipping_date };
    let current_time = new Date().getTime();
    let uniq_id = product_id+"_"+current_time;
    var pd_property = {'Carat Weight':getCarat_weight, 'Color': pd_color, 'Type': 'Try-at-Home', '_bundle_ids':product_variants, '_Unique_id':uniq_id };
    var check_band_size = '';
    if($('.qck_'+product_id+'_wrap .bs_options_wrapper').html() != undefined){
      let check_band_size = $('.qck_'+product_id+'_wrap .band_size_val.active').attr('data-val');
      // console.log("=> ", check_band_size);
      if(check_band_size == undefined || check_band_size.length == 0){
        $('.qck_'+product_id+'_wrap p.band_require_note').show();
        if($('.qck_'+product_id+'_wrap .vs_accordion.band_size_ac').hasClass('active') != true){
          $('.qck_'+product_id+'_wrap .vs_accordion.band_size_ac').trigger('click');  
        }
        $('html, body').animate({
          scrollTop: $("#bandSizeWrapper_"+product_id).offset().top-300
        }, 1000);
        $('.quick_view_overlay').css('display','none');
        return false;
        
        console.log('This JS s working 1')
      }else{
        console.log('This JS s working')
        // pd_property = {'_Carat_Weight':getCarat_weight, 'Band Size':check_band_size, '_bundle_ids':product_variants, '_shipping_data':shipping_date};
        pd_property = {'Carat Weight':getCarat_weight, 'Color': pd_color, 'Band Size':check_band_size, 'Type': 'Try-at-Home', '_bundle_ids':product_variants, '_Unique_id':uniq_id };
      }
    }
  //   console.log("product_variants! => ", product_variants);
  // console.log("pd_property => ", pd_property);
      tahAddToCartFunc(product_id, product_variants, pd_property, "quick_view");
}

function quickAddProductAjax(product_id, pd_color){
  let variant_id = $('#quickProductId_'+product_id).val();
  $('.quick_view_overlay').css('display','flex');

  var check_band_size = '';
  if($('.qck_'+product_id+'_wrap .bs_options_wrapper').html() != undefined){
    check_band_size = $('.qck_'+product_id+'_wrap .band_size_val.active').attr('data-val');
   console.log("=> ", check_band_size);
    if(check_band_size == undefined || check_band_size.length == 0){
      $('.qck_'+product_id+'_wrap p.band_require_note').show();
      if($('.qck_'+product_id+'_wrap .vs_accordion.band_size_ac').hasClass('active') != true){
        $('.qck_'+product_id+'_wrap .vs_accordion.band_size_ac').trigger('click');  
      }
      $('html, body').animate({
          scrollTop: $("#bandSizeWrapper_"+product_id).offset().top-300
      }, 1000);
      $('.quick_view_overlay').css('display','none');
      return false;
    }
  }
  var quantity = 1; // You can change this based on your needs.

  var eng_text = $('#engravingName_'+product_id).val();
  var eng_font_val = $('input[name="qck_font_'+product_id+'"]:checked').val();

  var properties = {};
  
  if(eng_text.length > 0 && check_band_size.length > 0){
    properties = {'Color': pd_color, "Band Size": check_band_size, "Engraving": eng_text, "Engraving Font": eng_font_val }
  }else if(check_band_size.length > 0){
    properties = {'Color': pd_color, "Band Size": check_band_size }
  }else if(eng_text.length > 0){
    properties = {'Color': pd_color, "Engraving": eng_text, "Engraving Font": eng_font_val }
  }
  
  $.ajax({
    type: 'POST',
    url: '/cart/add.js',
    data: {
      quantity: quantity,
      id: variant_id,
      properties: properties
    },
    dataType: 'json',
    success: function(){
      // Code to open the cart drawer here
      // window.open('/cart', '_self');
      location.href = location.href+'?minicart=open';
      $('.quick_view_overlay').css('display','none');
    }
  });
}

// open collection page sort filter popup
function openSortFilterPopup(){
  $('.custom_sort_popup').css("display","flex");
}

// sort by filter custom js
function selectSortFunc(sort_val, sort_val_name){
  let search_param = window.location.search;
  let new_filtre_val = '';
  if(window.location.search.indexOf("sort_by") == -1){
    search_param = search_param.replace("?","");
    if(search_param != ''){
      new_filtre_val = search_param+"&sort_by="+sort_val;
    }else{
      new_filtre_val = "sort_by="+sort_val;
    }
  }else{
    search_param = search_param.replace("?","");
    let param_array = search_param.split("&");
    for(var i=0;i<param_array.length;i++){
      if(param_array[i].indexOf("sort_by") >= 0){
        if(i == 0){
          new_filtre_val += "sort_by="+sort_val;
        }else{
          new_filtre_val += "&sort_by="+sort_val;
        }
        
      }else{
        if(i == 0){
          new_filtre_val += param_array[i];
        }else{
          new_filtre_val += "&"+param_array[i];
        }
      }
    }
  }


  
  $('.selected_sort_option').text(sort_val_name);
  $('.sort_pp_list span.sort_pp_option').removeClass('selected');
  $('.sort_pp_list span.sort_pp_option[data-value="'+sort_val+'"]').addClass('selected');
  customElements.get("facet-filters-form").renderPage(new_filtre_val);
  
  $('.custom_sort_popup').hide();
}

// shape stone custom filter js
function updateStoneShapeFilter(value, param_name) {
  let search_param = window.location.search;
  let new_filtre_val = '';

  let $selectedShape = $(".shape_filter_option[filter-val='" + value + "']");

  if (value !== 'all') {
    if (search_param.indexOf(value) === -1) {
      search_param = search_param.replace("?", "");
      if (search_param === '') {
        new_filtre_val = param_name + "=" + value;
      } else {
        if (search_param.indexOf("sort_by") >= 0) {
          let param_array = search_param.split("&");
          for (var i = 0; i < param_array.length; i++) {
            if (param_array[i].indexOf("sort_by") >= 0) {
              if (i === 0) {
                new_filtre_val += param_name + "=" + value + "&" + param_array[i];
              } else {
                new_filtre_val += "&" + param_name + "=" + value + "&" + param_array[i];
              }
            } else {
              if (i === 0) {
                new_filtre_val += param_array[i];
              } else {
                new_filtre_val += "&" + param_array[i];
              }
            }
          }
        } else {
          new_filtre_val = search_param + "&" + param_name + "=" + value;
        }
      }
      $selectedShape.addClass("selected");
    } else {
      $selectedShape.removeClass("selected");

      // Remove only the deselected filter from the URL
      search_param = search_param.replace("?", "");
      let param_array = search_param.split("&");
      let filtered_params = param_array.filter(param => param !== param_name + "=" + value);
      
      new_filtre_val = filtered_params.join("&"); // Reconstruct URL without the deselected filter
    }
  } else {
    search_param = search_param.replace("?", "");
    let param_array = search_param.split("&");
    let filtered_params = param_array.filter(param => !param.startsWith("filter.p.m.custom_filter.stone-shape="));
    //$(".shape_filter_option").toggleClass("selected");
    if($('.shape_filter_option').hasClass('selected')){
       $('.shape_filter_option').removeClass('selected');
    }
    new_filtre_val = filtered_params.join("&"); // Remove all stone-shape filters
  }

  // ✅ Ensure query string starts with "?" only if there are parameters
  new_filtre_val = new_filtre_val ? "" + new_filtre_val : "";

  // ✅ Update the URL properly
  customElements.get("facet-filters-form").renderPage(new_filtre_val);
}


function loadMoreProducts(next_url, type){
  $('.load_more_wrapper>button').text('Loading...');
  $('.load_more_wrapper>button').prop('disabled', true);
  // let nextElement = $('#paginationLoadMoreList .cl_page_link.active').next();
  let url_handle = next_url;

  $.ajax({
        url: url_handle,
    }).done(function (data, xhr){
     if(type == 'search'){
       let product_list = $(data).find('.template-search__results#product-grid>ul').html();
        product_list = product_list.replace(/\s{3,}/g, ' ').trim();
       
        $('.template-search__results#product-grid>ul').append(product_list);
     }else{  
       let product_list = $(data).find('ul#product-grid').html();
        product_list = product_list.replace(/\s{3,}/g, ' ').trim();
       
        $('.collection ul#product-grid').append(product_list);
        // $('.load_more_wrapper>button').text('Load more');
     }
      let btn_html = $(data).find('.load_more_wrapper').html();
      btn_html = btn_html.replace(/\s{3,}/g, ' ').trim();
      $('.load_more_wrapper').html(btn_html);
    
      setTimeout(function () {
        setProdImageHoverListeners();


        initializeFirstSwipers();
        
      },500);
    }).fail(function (err, xhr){
        console.log("error => ", err);
    });
  
  // $('#paginationLoadMoreList .cl_page_link').removeClass('active');
  // $(nextElement).addClass('active');

  // let check_next_element = $(nextElement).next().attr('data-url');
  // if(check_next_element == undefined){
  //   $('.load_more_wrapper>button').attr('disabled','disabled')
  // }
  
  
}

// ============ product page share option js

async function AndroidNativeShare(Title,URL,Description){
  if(typeof navigator.share==='undefined' || !navigator.share){
    // alert('Your browser does not support Android Native Share, it\'s tested on chrome 63+');
    $('.share_wrapper .social_actions').show();
  } else if(window.location.protocol!='https:'){
    // alert('Android Native Share support only on Https:// protocol');
    $('.share_wrapper .social_actions').show();
  } else {
    if(typeof URL==='undefined'){
      URL = window.location.href;
    }
    if(typeof Title==='undefined'){
      Title = document.title;
    }
    if(typeof Description==='undefined'){
      Description = 'Share your thoughts about '+Title;
    } 
    const TitleConst = "";
    const URLConst = URL;
    const DescriptionConst = Title;
     
    try{
      await navigator.share({title:TitleConst, text:DescriptionConst, url:URLConst});
    } catch (error) {
    console.log('Error sharing: ' + error);
    return;
    }   
  }
} 
 
$(".share_button").click(function(BodyEvent){
  var meta_desc,meta_title,meta_url
  if(document.querySelector('meta[property="og:description"]')!=null) {
    meta_desc = document.querySelector('meta[property="og:description"]').content;
  }
  if(document.querySelector('meta[property="og:title"]')!=null) {
    meta_title = document.querySelector('meta[property="og:title"]').content;
  }
  if(document.querySelector('meta[property="og:meta_url"]')!=null) {
    meta_url = document.querySelector('meta[property="og:meta_url"]').content;
  }
  AndroidNativeShare(meta_title, meta_url,meta_desc); 
});


// ============ product page share option js end


// Add warranty product on cart page

function addWarrantyProduct(item_id, parent_id) {
    $('.add_warranty_item .warrenty_'+parent_id+'_loading').removeClass('hidden');
  $.ajax({
      type: 'POST',
      url: '/cart/add.js',
      data: {
        quantity: 1,
        id: item_id,
        properties:{
          "warranty_parent_id":parent_id
        }
      },
      dataType: 'json',
      success: function(){
        let current_url = window.location.href;
        console.log("=> ", current_url.indexOf('cart'));
        
        if(current_url.indexOf('cart') > 0){
          location.href = location.href;
        }else{
          location.href = location.href+'?minicart=open';
        }
        // location.reload();
        // location.href = location.href+'?minicart=open';
      }
    });
}

function removeWarrantyProduct(item_id, type){
  if(type == 'warrenty'){
    $('.warrenty_'+item_id+'_loading').removeClass('hidden');
  }else{
    $('.parent_'+item_id+'_loading').removeClass('hidden');
  }
  
  event.preventDefault();
  let get_child_id = $('.pd_'+item_id+'_child').attr('child-data-id');
  var lineItemUpdates = {};
  lineItemUpdates['updates'] = {};
  lineItemUpdates['updates'][Number(item_id)] = 0;
  if(get_child_id != undefined){
    lineItemUpdates['updates'][Number(get_child_id)] = 0
  }  
  jQuery.post(window.Shopify.routes.root + 'cart/update.json?get=1s', lineItemUpdates)
  .done(function(){
    // location.reload();
    // location.href = location.href+'?minicart=open';
    let current_url = window.location.href;        
        if(current_url.indexOf('cart') > 0){
          location.href = location.href;
        }else{
          location.href = location.href+'?minicart=open';
        }
  })
  .fail(function(){
    console.log( "error" );
  });
  
}

function removeTahProduct(item_id, item_key){
  event.preventDefault();
  $.ajax({
    type: 'GET',
    url: '/cart.js', // Endpoint for retrieving cart data
    dataType: 'json',
    success: function(cartData) {
      // `cartData` contains information about the current cart
      // console.log(cartData);
      var data_array = {items:[]};
      var lineItemUpdates = {};
      lineItemUpdates['updates'] = {};
      lineItemUpdates['updates'][item_key] = 0;
      
      if(cartData.item_count > 0){

        var tahProductCount = $.map(cartData.items, function(item, index){
              if(item.product_type == 'Try-At-Home' && item.key != item_key){
                return item;
              }
        });
        // var tah_kit_number = tahProductCount.length / 3;
        // tah_kit_number = Math.ceil(tah_kit_number);
        // var kitArray = {};
        if(tahProductCount.length > 0){

          if(tahProductCount.length == 1){
            $.map(tahProductCount, function(item, index){
                 lineItemUpdates['updates'][item.key] = 0; 
              // Need Id for item Bundle 1 and push in item
                 let updated_bundle_id = item.properties._bundle_ids["Bundle3"];
                 console.log('Bundle_three');
                 data_array.items.push({"id":parseInt(updated_bundle_id),"quantity":1,"properties":item.properties});
            });
            
          }else if(tahProductCount.length == 2){
            $.map(tahProductCount, function(item, index){
                // if(index == 1){
                  lineItemUpdates['updates'][item.key] = 0; 
                  let updated_bundle_id = item.properties._bundle_ids["Bundle2"];
                  console.log('Bundle_two');
                  data_array.items.push({"id":parseInt(updated_bundle_id),"quantity":1,"properties":item.properties});
                // }
            });
          }
          // else{
          //   alert("You already have 3 pieces in your kit. Please remove one from your kit before adding.");
          // }

        }
        // else{
        //   data_array.items.push({"id":parseInt(product_variants.Bundle3),"quantity":1,"properties":pd_property});
        // }
        
        // console.log("tah product => ",tahProductCount.length);
        
      }
      // else{
      //   data_array.items.push({"id":parseInt(product_variants.Bundle3),"quantity":1,"properties":pd_property});
      // }
      // console.log('Removed array => ', lineItemUpdates);
      // console.log('Data array => ', data_array);
      
        jQuery.post(window.Shopify.routes.root + 'cart/update.json?get=1s', lineItemUpdates)
        .done(function(){
          console.log("Removed product.");
          if(data_array.items.length > 0){
            $.ajax({
              type: 'POST',
              url: '/cart/add.js',
              dataType: 'json',
              data: data_array,
              success: function() {
                location.href = location.href+'?minicart=open';
                // location.reload();
              },
              error: function(XMLHttpRequest, textStatus) {
                alert('Error: ' + textStatus);
              }
            });
          }else{
            // location.reload();
            location.href = location.href+'?minicart=open';
            console.log("Variant not selected!");
          }
              
        })
        .fail(function(){
          console.log( "error" );
        });
      
    },
    error: function(XMLHttpRequest, textStatus) {
      console.log('Error: ' + textStatus);
    }
  });
  
}

function updateProductMediaSlider(variant_id){
  $('.product_media_overlay').css('display','flex');
  let slider_class = '.pd_'+variant_id+'_slider';
  if($('.product_media_wrapper').find(slider_class).length > 0){
    splide.destroy();
    // $('.product_media_wrapper .splide').css("display","none");
    splide = new Splide( slider_class, {
               
              perPage: 1,
              type   : 'slide',
              start: 0,
              focus  : 'center',
              perMove: 1,
              drag   : 'free',
              gap    : '0rem',
              pagination: true
            });
            splide.on( 'mounted', function () {
              document.querySelector('.splide').classList.remove('splide-is-loading');
               $('.product_media_overlay').css('display','none');
            });
    
            splide.mount();
    // $('.product_media_wrapper .splide'+slider_class).css("display","block");
  }else{
    if($('.product_media_wrapper').find('.splide.is-active').hasClass('main_product_slider') == false){
      splide.destroy();
      // $('.product_media_wrapper .splide').css("display","none");
      splide = new Splide( '.main_product_slider', {
                 
                perPage: 1,
                type   : 'slide',
                start: 0,
                focus  : 'center',
                perMove: 1,
                drag   : 'free',
                gap    : '0rem',
                pagination: true
              });
              splide.on( 'mounted', function () {
                document.querySelector('.splide').classList.remove('splide-is-loading');
               $('.product_media_overlay').css('display','none');
            });
              splide.mount();
      // $('.product_media_wrapper .splide.main_product_slider').css("display","block");
    }else{
      $('.product_media_overlay').css('display','none');
    }
  }
  
}


document.addEventListener('DOMContentLoaded', function () {
  const productVariants = window.productVariants || [];

  function findVariantByCarat(caratValue) {
    return productVariants.find(variant => {
      return variant.options.includes(caratValue);
    });
  }

  function updateSliderForVariant(variantId) {
    // Hide all sliders
    document.querySelectorAll('.main_product_slider, .variant-media-slider').forEach(slider => {
      slider.style.display = 'none';
    });

    // Show variant slider if it exists
    const variantSlider = document.getElementById(`variant-slider-${variantId}`);
    if (variantSlider) {
      variantSlider.style.display = 'block';
    } else {
      const fallback = document.getElementById('default-media-slider');
      if (fallback) fallback.style.display = 'block';
    }
  }

  // Listen for radio button change on Carat Weight group
  const caratRadios = document.querySelectorAll('input[type="radio"][name="Choose Carat Weight"]');
  caratRadios.forEach(radio => {
    radio.addEventListener('change', function () {
      const selectedCarat = this.value.trim();
      const matchedVariant = findVariantByCarat(selectedCarat);
      if (matchedVariant) {
        updateSliderForVariant(matchedVariant.id);
      }
    });
  });

  // Trigger once on page load
  const selected = document.querySelector('input[name="Choose Carat Weight"]:checked');
  if (selected) {
    const initialVariant = findVariantByCarat(selected.value.trim());
    if (initialVariant) {
      updateSliderForVariant(initialVariant.id);
    }
  }
});

function removeTAHkit(){
   event.preventDefault();
  $('.tahKit_remove_modal .button').prop('disabled', true);
  $.ajax({
    type: 'GET',
    url: '/cart.js', // Endpoint for retrieving cart data
    dataType: 'json',
    success: function(cartData) {
      var lineItemUpdates = {};
      lineItemUpdates['updates'] = {};
      if(cartData.item_count > 0){
        var tahProductCount = $.map(cartData.items, function(item, index){
              if(item.product_type == 'Try-At-Home'){
                lineItemUpdates['updates'][item.key] = 0;
                return item;
              }
        });
      }
      console.log('Removed array => ', lineItemUpdates);
      
        jQuery.post(window.Shopify.routes.root + 'cart/update.json?get=1s', lineItemUpdates)
        .done(function(){
            console.log("Removed product.");
            // location.reload();            
          location.href = location.href+'?minicart=open';
        })
        .fail(function(){
          console.log( "error" );
        });
    },
    error: function(XMLHttpRequest, textStatus) {
      console.log('Error: ' + textStatus);
    }
  });
}

function openDiamondInfoPopup(){
    $('.diamond_clarity_modal.vs_custom_modal').css('display','flex');
}
function openMetalInfoPopup(){
    $('.metal_info_modal.vs_custom_modal').css('display','flex');
}
function openBrassInfoPopup() {
  $('.brass_info_modal.vs_custom_modal').css('display','flex');
}
function openCubicInfoPopup() {
  event.preventDefault();
  $('.cubic_info_modal.vs_custom_modal').css('display','flex');
}

function showAllVisualFilter(value){
  // let search_param = window.location.search;
  let new_filtre_val = value;
  customElements.get("facet-filters-form").renderPage(new_filtre_val);
}
// Visaul collection custom filter js
function updateVisualFilter(value, param_name){
    
  let search_param = window.location.search;
  let new_filtre_val = '';
 
  if(search_param.indexOf(value) == -1){
    search_param = search_param.replace("?","");
    if(search_param == ''){
      new_filtre_val = param_name+"="+value;
    }else{
      if(search_param.indexOf("sort_by") >= 0){
        let param_array = search_param.split("&");
        for(var i=0;i<param_array.length;i++){
          if(param_array[i].indexOf("sort_by") >= 0){
            if(i == 0){
              new_filtre_val += param_name+"="+value+"&"+param_array[i];
            }else{
              new_filtre_val += "&"+param_name+"="+value+"&"+param_array[i];
            }
          }else{
            if(i == 0){
              new_filtre_val += param_array[i];
            }else{
              new_filtre_val += "&"+param_array[i];
            }
          }
        }
      }else{
        new_filtre_val += search_param+"&"+param_name+"="+value
      }
    }
  }else{
    return;
  }
  customElements.get("facet-filters-form").renderPage(new_filtre_val);
}

// --- ring size printer -----------
$(document).ready(function() {
    var pdfUrl = "https://cdn.shopify.com/s/files/1/0258/2223/2647/files/Verlas_RingSizer_All-2.pdf?v=1679586180"
    // Function to open PDF URL and trigger print
    $("#printerRingSize").click(function() {
      // Open a new window or tab with the PDF URL
      var pdfWindow = window.open(pdfUrl, '_blank');
      // Wait for the PDF to load before triggering print
      pdfWindow.onload = function() {
        // Trigger the print function
        pdfWindow.print();
      };
    });
    $('.ring_modal_info').click(function(){
      $('.print_text_info').css('display','block');
    })
});
// --- end ring size printer -----------






// // ---------- add Free gift product -----------
// const freeProductVariantId = 42918101188747; // Replace with your free product's variant ID
// const freeProductThreshold = 7500; // Set your threshold value
// var totalCartValue = 0;
// // Function to get the cart contents
//   function getCart() {
//     return fetch('/cart.js')
//       .then((response) => response.json());
//   }

//   // Function to add a product to the cart
//   function addProductToCart(variantId, quantity = 1) {
//     return fetch('/cart/add.js', {
//       method: 'POST',
//       headers: {
//         'Content-Type': 'application/json',
//       },
//       body: JSON.stringify({ id: variantId, quantity }),
//     }).then((response) => response.json());
//   }

//   // Function to remove a product from the cart
//   function removeProductFromCart(variantId) {
//     // return fetch('/cart/change.js', {
//     //   method: 'POST',
//     //   headers: {
//     //     'Content-Type': 'application/json',
//     //   },
//     //   body: JSON.stringify({ id: variantId, quantity: 0 }),
//     // }).then((response) => response.json())
//     // .catch((error) => console.log(error));
//       var lineItemUpdates = {};
//       lineItemUpdates['updates'] = {};
//       lineItemUpdates['updates'][variantId] = 0;
//     return fetch(`${window.Shopify.routes.root}cart/update.json?get=1s`, {
//           method: 'POST',
//           headers: {
//             'Content-Type': 'application/json',
//           },
//           body: JSON.stringify(lineItemUpdates),
//         })
//         .then((response) => {
//           if (!response.ok) {
//             throw new Error('Network response was not ok');
//           }
//           response.json();
//           // console.log("Removed product.");
//           // Update the location
//           // location.href = location.href + '?minicart=open';
//         })
//         .catch((error) => {
//           console.error('Error:', error);
//         });
//   }

//   // Function to check and add/remove free product
//   function checkFreeProduct() {
//     // console.log("check free product function called!")
//     getCart().then((cart) => {
//       const cartTotal = cart.original_total_price / 100; // Shopify returns the total in cents
//       totalCartValue = cartTotal;
//       const freeProductInCart = cart.items.some((item) => item.variant_id === freeProductVariantId);
//       // console.log("cartTotal : ", cartTotal, " | freeProductThreshold : ", freeProductThreshold);
//       // console.log("freeProductInCart : ", freeProductInCart);
//       if (cartTotal > freeProductThreshold && !freeProductInCart) {
//         // console.log("1 condition");
//         // Add free product if not already in the cart
//         addProductToCart(freeProductVariantId).then(() => {
//           // console.log('Free product added to cart');
//           // updateCartDrawer(); // Optionally update the cart drawer
//           let current_url = window.location.href;        
//           if(current_url.indexOf('cart') > 0){
//             location.href = location.href;
//           }else{
//             $("#CartDrawer").load(location.href + " #CartDrawer>*");
//           }
//         });
//       } else if (cartTotal <= freeProductThreshold && freeProductInCart) {
//         // console.log("2 condition");
//         // Remove free product if total drops below the threshold
//         removeProductFromCart(freeProductVariantId).then(() => {
//           // console.log('Free product removed from cart');
//           // updateCartDrawer(); // Optionally update the cart drawer
//           let current_url = window.location.href;        
//           if(current_url.indexOf('cart') > 0){
//             location.href = location.href;
//           }else{
//             $("#CartDrawer").load(location.href + " #CartDrawer>*");
//           }
//         });
//       }
//     });
//   }

// document.addEventListener('DOMContentLoaded', () => {
//   // For the quantity buttons (plus and minus)
// $('body').on('click', '.quantity__button, .quantity__input', function(event) {
//     console.log("Quanity button clicked!");
//     let old_sub_total = '';
//     if($('.totals.estimate_total .totals__subtotal-value').length == 1){
//       old_sub_total = $('.totals.estimate_total .totals__subtotal-value').text();
//     }else{
//       old_sub_total = $('.totals.total_estimate .totals__subtotal-value').text();
//     }
//     // console.log("old_sub_total : ", old_sub_total);
 
//     var intervalId = setInterval(function() {
//       let new_sub_total = '';
//       if($('.totals.estimate_total .totals__subtotal-value').length == 1){
//         new_sub_total = $('.totals.estimate_total .totals__subtotal-value').text();
//       }else{
//         new_sub_total = $('.totals.total_estimate .totals__subtotal-value').text();
//       }
//       // console.log("new_sub_total : ", new_sub_total);

//       if (old_sub_total !== new_sub_total) {
//         let current_url = window.location.href;        
//         if(current_url.indexOf('cart') > 0){
//         	if($('.remaining-free-price').length > 0){
//         		getCart().then((cart) => {
// 	      		  const cartTotal = cart.original_total_price / 100;
// 	      		  let check_price = freeProductThreshold - cartTotal;
// 	      		  check_price = check_price * 100;
// 	      		  if(check_price >= 0){
// 	      		  	$('.remaining-free-price').text(Shopify.formatMoney(check_price));
// 	      		  }
// 	      		});
//             }
//         }
//         clearInterval(intervalId); // Stop the interval when the price changes
//         checkFreeProduct(); // Call your function when the price changes
//         // console.log('Interval cleared because condition was met');
//       }
//     }, 1000); // Runs every 2 seconds (adjustable)
//   });

//   // Trigger free product check on initial page load
//   checkFreeProduct();

// });
  
// // ----------End add Free gift product -----------


// slick JS starts
$('.featuredSlider').slick({
  dots: true,
  arrows: true,
  slidesToShow: 4,
  slidesToScroll: 4,
  autoplay: false,
  prevArrow:
    '<span class="slick-arrow slick-prev"><svg style="transform: rotate(90deg); margin-bottom: -3px;" xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="350 0 20 20"><path stroke="#290A68" stroke-width=".75" stroke-linecap="round" stroke-linejoin="round" fill="none" d="m367 6-8.48 8L350 6"/></svg></span>',
    nextArrow:
    '<span class="slick-arrow slick-next"><svg style="transform: rotate(270deg); margin-top: -3px;" xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="350 0 20 20"><path stroke="#290A68" stroke-width=".75" stroke-linecap="round" stroke-linejoin="round" fill="none" d="m367 6-8.48 8L350 6"/></svg></span>',
  infinite: true,
  responsive: [
    {
      breakpoint: 1041,
      settings: {
        slidesToShow: 3,
        slidesToScroll: 3,
      },
    },
    {
      breakpoint: 990,
      settings: {
        slidesToShow: 3,
        slidesToScroll: 3,
      },
    },
    {
      breakpoint: 551,
      settings: {
        slidesToShow: 2,
        slidesToScroll: 2,
      },
    },
  ],
});
$('.home-testimonial-slider').slick({
  dots: true,
  arrows: true,
  slidesToShow: 4,
  slidesToScroll: 4,
  autoplay: false,
  prevArrow:
    '<span class="slick-arrow slick-prev"><svg style="transform: rotate(90deg); margin-bottom: -3px;" xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="350 0 20 20"><path stroke="#290A68" stroke-width=".75" stroke-linecap="round" stroke-linejoin="round" fill="none" d="m367 6-8.48 8L350 6"/></svg></span>',
    nextArrow:
    '<span class="slick-arrow slick-next"><svg style="transform: rotate(270deg); margin-top: -3px;" xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="350 0 20 20"><path stroke="#290A68" stroke-width=".75" stroke-linecap="round" stroke-linejoin="round" fill="none" d="m367 6-8.48 8L350 6"/></svg></span>',
  infinite: true,
  responsive: [
    {
      breakpoint: 1041,
      settings: {
        slidesToShow: 3,
        slidesToScroll: 3,
      },
    },
    {
      breakpoint: 990,
      settings: {
        slidesToShow: 3,
        slidesToScroll: 3,
      },
    },
    {
      breakpoint: 551,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1,
      },
    },
  ],
});
$('.complete_look_slider').slick({
  dots: true,
  arrows: true,
  slidesToShow: 4,
  slidesToScroll: 4,
  autoplay: false,
  prevArrow:
    '<span class="slick-arrow slick-prev"><svg style="transform: rotate(90deg); margin-bottom: -3px;" xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="350 0 20 20"><path stroke="#290A68" stroke-width=".75" stroke-linecap="round" stroke-linejoin="round" fill="none" d="m367 6-8.48 8L350 6"/></svg></span>',
    nextArrow:
    '<span class="slick-arrow slick-next"><svg style="transform: rotate(270deg); margin-top: -3px;" xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="350 0 20 20"><path stroke="#290A68" stroke-width=".75" stroke-linecap="round" stroke-linejoin="round" fill="none" d="m367 6-8.48 8L350 6"/></svg></span>',
  infinite: true,
  responsive: [
    {
      breakpoint: 1041,
      settings: {
        slidesToShow: 3,
        slidesToScroll: 3,
      },
    },
    {
      breakpoint: 990,
      settings: {
        slidesToShow: 3,
        slidesToScroll: 3,
      },
    },
    {
      breakpoint: 551,
      settings: {
        slidesToShow: 2,
        slidesToScroll: 2,
      },
    },
  ],
});
// slick JS starts

window.addEventListener("load", function() {
  const el = document.querySelector("details.mobile-facets__disclosure.disclosure-has-popup");
  if (el) {
    el.style.pointerEvents = "unset";
    console.log("✅ pointer-events set to unset");
  } else {
    console.warn("⚠️ Element not found");
  }
});

// const freeProductVariantId = 47028882243723;

// function getCart() {
//   return fetch('/cart.js')
//     .then((response) => response.json());
// }

// function removeProductFromCart(variantId) {
//     var lineItemUpdates = {};
//     lineItemUpdates['updates'] = {};
//     lineItemUpdates['updates'][variantId] = 0;
//     return fetch(`${window.Shopify.routes.root}cart/update.json?get=1s`, {
//         method: 'POST',
//         headers: {
//           'Content-Type': 'application/json',
//         },
//         body: JSON.stringify(lineItemUpdates),
//       })
//       .then((response) => {
//         if (!response.ok) {
//           throw new Error('Network response was not ok');
//         }
//         response.json();
//       })
//       .catch((error) => {
//         console.error('Error:', error);
//       });
// }

// function checkFreeProduct() {
//   getCart().then((cart) => {
//     const freeProductInCart = cart.items.some((item) => item.variant_id === freeProductVariantId);

//     const onlyFreeProductInCart = cart.items.length === 1 && freeProductInCart;
    
//     if (onlyFreeProductInCart) {
//       removeProductFromCart(freeProductVariantId).then(() => {
//         let current_url = window.location.href;        
//         if(current_url.indexOf('cart') > 0){
//           location.href = location.href;
//         }else{
//           //$("#CartDrawer").load(location.href + " #CartDrawer>*");
//           location.href = location.href+'?minicart=open';
//         }
//       });
//     }
//   });
// }

// document.addEventListener('DOMContentLoaded', () => {
//   // const offerWrapper = document.querySelector('.OfferProduct-wrapper');
//   // getCart().then((cart) => {
//   //   if(cart.items.length === 0){
//   //     offerWrapper.style.opacity = '0.5';
//   //     offerWrapper.style.pointerEvents = 'none';
//   //   }
//   // });
//   console.log("custom.js loading");
//   checkFreeProduct();
// });